import axiosInstance from "../axios_instance";

export async function createSeedConfigs(body) {
  try {
    return await axiosInstance.post(`seedConfigs/`, body);
  } catch (error) {
    return error;
  }
}

export async function updateSeedConfigs(body, id) {
  try {
    return await axiosInstance.put(`seedConfigs/${id}`, body);
  } catch (error) {
    return error;
  }
}

export async function getSeedConfigs(key) {
  try {
    return await axiosInstance.get(`seedConfigs/`, {
      params: {
        key: key,
      },
    });
  } catch (error) {
    return error;
  }
}
